import { SxProps, Theme } from '@mui/material';
import { CrmColors } from '../../crm-theme';

const ZONE_HEIGHT = 46;

/// Fixo no rodapé da janela e transparente ao mouse fora do arraste; aparece com `visible`.
export const dropBarSx = (visible: boolean): SxProps<Theme> => ({
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    px: 2,
    pb: 1.25,
    display: 'flex',
    gap: 1.25,
    pointerEvents: 'none',
    zIndex: 1300,
    opacity: visible ? 1 : 0,
    transition: 'opacity .15s ease',
});

/// Escondida, a zona desce para fora da tela; com o card por cima, ganha a cor da ação.
export const dropZoneSx = (cc: CrmColors, color: string, visible: boolean, isOver: boolean): SxProps<Theme> => ({
    flex: 1,
    height: ZONE_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    borderRadius: '10px',
    border: `2px dashed ${isOver ? color : cc.borderStrong}`,
    background: isOver ? `${color}26` : cc.cardBg,
    color: isOver ? color : cc.textSecondary,
    transform: visible ? 'translateY(0)' : `translateY(${ZONE_HEIGHT + 24}px)`,
    transition: 'transform .18s ease, background .12s, border-color .12s, color .12s',
    boxShadow: visible ? '0 -6px 24px rgba(0,0,0,.25)' : 'none',
});
